import { useMemo } from 'react';

import { L1_VALUES } from 'Deer/constants/routes';
import { useRouteToMyTeamLevels, useRouteToNavLevels } from 'Deer/hooks/useRouteToL3';

const useDeerL1PageBasedL3Routes = () => {
  const { l3Options: tabsDeer } = useRouteToMyTeamLevels();
  const { l3Options: tabsDeerCompanyLevel, l1Module } = useRouteToNavLevels();

  const memoizedValues = useMemo(() => {
    if (l1Module === L1_VALUES.company) {
      return { l3Options: tabsDeerCompanyLevel };
    }
    return { l3Options: tabsDeer };
  }, [l1Module, tabsDeer, tabsDeerCompanyLevel]);

  return memoizedValues;
};

export default useDeerL1PageBasedL3Routes;
